import { combineReducers } from 'redux';
import registrations from './registrations';
import registrationPoints from './registrationPoints';
import labels from './labels';

const reducer = combineReducers({
  registrations,
  registrationPoints,
  labels
});

export default reducer;
